import React from "react";
import { ArrowRight } from "lucide-react";
import { cardCls, labelCls } from "./tokens";

/**
 * DepartmentCard — module entry tile.
 * Variants: active (default) | inactive
 */
export default function DepartmentCard({
  title,
  description,
  count,
  Icon,
  status = "active", // "active" | "inactive"
  cta = "Open",
  onClick,
  testId,
}) {
  const inactive = status === "inactive";
  const tid =
    testId ||
    `dept-card-${(title || "").toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={inactive}
      data-testid={tid}
      className={`${cardCls} group p-6 text-left transition-colors ${
        inactive
          ? "opacity-60 cursor-not-allowed"
          : "hover:border-onedesk-primary hover:shadow-od-subtle"
      } flex flex-col gap-4`}
    >
      <div className="flex items-start justify-between gap-3">
        {Icon && (
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-od-input bg-onedesk-bg">
            <Icon className="h-5 w-5 text-onedesk-primary" strokeWidth={2.25} />
          </span>
        )}
        <span
          className={`text-xs font-bold uppercase tracking-wider rounded-od-input px-3 py-1 ${
            inactive
              ? "bg-onedesk-bg text-onedesk-textSecondary"
              : "bg-onedesk-primary/10 text-onedesk-primary"
          }`}
        >
          {inactive ? "Inactive" : "Active"}
        </span>
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="font-bold text-lg text-onedesk-textPrimary">{title}</h3>
        {description && (
          <p className="font-medium text-sm text-onedesk-textSecondary leading-relaxed">
            {description}
          </p>
        )}
      </div>

      <div className="flex items-center justify-between border-t border-onedesk-border pt-3">
        <div className="flex flex-col">
          <span className={labelCls}>Open Items</span>
          <span className="font-bold text-xl text-onedesk-textPrimary">
            {count ?? "—"}
          </span>
        </div>
        <span
          className={`inline-flex items-center gap-1 text-sm font-bold ${
            inactive ? "text-onedesk-textSecondary" : "text-onedesk-primary"
          } group-hover:gap-2 transition-all`}
        >
          {cta}
          <ArrowRight className="h-4 w-4" strokeWidth={2.5} />
        </span>
      </div>
    </button>
  );
}
